// import { fromJS } from "immutable";

// import {
//   LOGIN_ACTION_SUCCEEDED,
//   SIGNUP_ACTION_SUCCEEDED
// } from "../../components/Login/constants";
import {
  RATE_CARD_SUCCEDED,
  PLAN_SIZE_CHANGE,
  OPTED_PLAN,
  CHECK_OUT_PAYMENT_SUCCEDED,
  CHECK_OUT_PAYMENT,
  CHECK_OUT_PAYMENT_FAILED,
  PAYMENT_CLOSE,
  PAYMENT_WEBHOOK,
  PAYMENT_WEBHOOK_FAILED,
  PAYMENT_WEBHOOK_SUCCEEDED,
  PAYMENT_ACKNOWLEDGE,
  USER_CURRENT_PLAN_SUCCEDED,
  USER_CURRENT_PLAN_FAILED,
  CLOSE_CART,
  PAYMENT_URL_PROD,
  PAYMENT_URL_TIER1,
  PAYMENT_URL_STAGING
} from "../../common/constants";



const initialState = {
  ratecardList: {},
  eligibleRateCards: { plans: [] },
  optedPlanDetails: {},
  paymentURL: "",
  currentValue: 0,
  // min: 1000,
  // max: 12000,
  // step: 1000,
  showCart: "hide",
  showDetails: "block",
  invoiceInfo: "",
  userCurrentPlan: {},
  paymentPending: true
}


export const subscribePlanReducer = (state = initialState, action) => {
  //console.log('reducer action:' + JSON.stringify(action));
  switch (action.type) {
    case RATE_CARD_SUCCEDED:
      return {
        ...state,
        ratecardList: action.ratecardList
      };
    case PLAN_SIZE_CHANGE:
      return {
        ...state,
        //eligibleRateCards: action.ratecardList.Plans[action.size],
        currentValue: action.size,
        eligibleRateCards: action.ratecardList.Plans[action.size]
      };
    case OPTED_PLAN:
      return {
        ...state,
        optedPlanDetails: action.planDetails,
        showCart: "block",
        showDetails: "hide"
      };
    case CHECK_OUT_PAYMENT:
      return {
        ...state,
        disableButton: true,
        invoiceData: action.invoiceData,
        paymentPending: true
      };
    case CHECK_OUT_PAYMENT_SUCCEDED:
      if (process.env.REACT_APP_ENV == "production") {
        return {
          ...state,
          invoiceInfo: action.invoiceInfo,
          paymentURL: PAYMENT_URL_PROD + action.invoiceInfo.key_token
        };
      } else if (process.env.REACT_APP_ENV == "staging") {
        return {
          ...state,
          invoiceInfo: action.invoiceInfo,
          paymentURL: PAYMENT_URL_STAGING + action.invoiceInfo.key_token
        };
      } else {
        return {
          ...state,
          invoiceInfo: action.invoiceInfo,
          paymentURL: PAYMENT_URL_TIER1 + action.invoiceInfo.key_token
        };
      }
    case PAYMENT_CLOSE:
      return {
        ...state,
        disableButton: false,
        paymentURL: ""
      };
    case CLOSE_CART:
      return {
        ...state,
        showCart: "hide",
        showDetails: "block",
        optedPlanDetails: {}
      };
    case CHECK_OUT_PAYMENT_FAILED:
      return {
        ...state
      };

    case USER_CURRENT_PLAN_SUCCEDED:
      return {
        ...state,
        userCurrentPlan: action.userCurrentPlan
      };
    case USER_CURRENT_PLAN_FAILED:
      return {
        ...state
      };
    case PAYMENT_WEBHOOK:
      return {
        ...state,
        paymentPending: false
      };
    case PAYMENT_ACKNOWLEDGE:
      return {
        ...state,
        paymentPending: false
      };
    case PAYMENT_WEBHOOK_SUCCEEDED:
      return {
        ...state
      };
    case PAYMENT_WEBHOOK_FAILED:
      return {
        ...state
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Containers/Pricing/reducer.js